import { SvgIconProps } from './icon-props';

export default function ItineraryDefault({ height = 20, width = 20 }: SvgIconProps) {
	return (
		<svg
			width={width}
			height={height}
			fill="none"
			viewBox="0 0 32 32"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="m8.99999 7.40002h-1.22v-4h1.22zm20.00001 3.81998v17c0 .3298-.1303.6463-.3626.8804-.2322.2341-.5476.367-.8774.3696h-23.52001c-.1676-.0012-.33325-.0361-.48709-.1026s-.29273-.1633-.40842-.2846c-.11568-.1213-.20579-.2646-.26497-.4214s-.08622-.3239-.07952-.4914v-22.37998c-.00001-.32979.13032-.64623.36258-.88036.23226-.23414.54764-.367.87742-.36964h2.3v1.46h-2.27v5.17998h23.52001v-5.17998h-2.3v-1.46h2.3c.1627-.00149.324.03012.4742.09293.1501.0628.2859.15548.399.2724.1132.11693.2014.25565.2593.40773.0579.15209.0843.31436.0775.47694zm-1.21 1.3h-23.52001v15.68h23.52001zm-6-7.99998h-11.53v1.48h11.51zm2.51-1.12h-1.3v4h1.24z"
				fill="#000"
			/>
		</svg>
	);
}
